module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_03@3x-93c993857ad4334f18ded3db48cb6d0f.webp";